import React, { useContext, useState, Suspense } from 'react';

import '../styles/Homepage.css';
import { bool } from 'prop-types';
import SEO from './SEO';
import AppContext from '../components/context/AppContext';
import { useMemo } from 'react';
import AboutUs from './AboutUs';
import HeroSlideshow from './HeroSlideshow';
import { Link } from 'react-router-dom';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';
import { OverlayTrigger } from 'react-bootstrap';
import LoadingFallback from './LoadingFallback';
import InfoCardGrid from './InfoCardGrid';
import PartsList from './PartsList';
import FeaturedProducts from './FeaturedProducts';
const QuoteForm = React.lazy(() => import('./QuoteForm'));

// Homepage component
// Rendered at the root path
const Homepage = ({ isMobile }) => {
    const { appContext } = useContext(AppContext);
    const articlePath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.ARTICLE_PATH });
    const appConfig = appContext.config.themeConfig;
    const slideShowItems = useMemo(() => [...appConfig.heroSection.images.map((section) => ({
        backgroundUrl: section.backgroundUrl,
    }))], [appConfig]);
    const [toggle, setToggle] = useState(false);

    const handleToggle = (toggle) => {
        setToggle(toggle);
    };

    return (<>
        <SEO
            seoTitle={appConfig.seoTitle ?? appContext.config.storeName}
            seoType={'website'}
            seoDescription={appConfig.seoDescription}
            canonicalUrl={process.env.APP_URL}
        />
        <div
            className={'section'}
        >
            <HeroSlideshow
                isMobile={isMobile}
                items={slideShowItems}
            />
            <InfoCardGrid
                cards={appConfig.infoCards}
            />
            <PartsList
                parts={appConfig.parts}
            />
            {isMobile ? (
                <Link
                    to={`${articlePath[0].fullPath}`}
                    className={'home--blog-link'}
                >
                    Visit LiftPartsWarehouse Blogs
                </Link>
            ): null}
            <Suspense
                fallback={<LoadingFallback />}
            >
                <OverlayTrigger
                    show={toggle}
                    overlay={<QuoteForm
                        handleToggle={handleToggle}
                    />}
                >
                    <div
                        className={'home--quote-button-wrapper'}
                    >
                        <button
                            onClick={() => handleToggle(true)}
                        >
                            Request a quote
                        </button>
                    </div>
                </OverlayTrigger>
            </Suspense>
            <AboutUs
                descriptions={appConfig.homePageHighlights}
            />
            <FeaturedProducts />
        </div>
    </>);
};

Homepage.propTypes = {
    isMobile: bool,
};

export default Homepage;